import type { ReactNode } from 'react'
import type { UseFormReturn } from 'react-hook-form'

import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form'
import { Input } from '@/components/ui/input'

import type { AgencyFormSchemaType } from '../agency-form.schema'

interface AgencyFormNameFieldProps {
  form: UseFormReturn<AgencyFormSchemaType>
  isDisabled?: boolean
}

export const AgencyFormNameField = ({
  form,
  isDisabled = false,
}: AgencyFormNameFieldProps): ReactNode => (
  <FormField
    control={form.control}
    name="name"
    render={({ field }) => (
      <FormItem>
        <FormLabel>
          Agency Name <span className="text-destructive">*</span>
        </FormLabel>
        <FormControl>
          <Input
            placeholder="Enter agency name"
            disabled={isDisabled}
            className="agency-form-name-input"
            {...field}
          />
        </FormControl>
        <FormMessage />
      </FormItem>
    )}
  />
)

AgencyFormNameField.displayName = 'AgencyFormNameField'
